module.exports = "/_next/static/images/slide2-266c221054d0ec153affd7fa3149d308.webp";